import { useEffect, useRef } from 'react';
import type { WebappResponse } from '@eventbrite/event-listing-service-client';

import { extractFacebookClickIds, useAttributionClickTracking } from '@eventbrite/legacy-infra.clid-courier';

type UseAttributionTrackingEffectArgs = {
  pageContext: WebappResponse | null | undefined;
  isInitialized: boolean;
};

export function useAttributionTrackingEffect({ pageContext, isInitialized }: UseAttributionTrackingEffectArgs) {
  const { sendClickData } = useAttributionClickTracking();
  const attributionTrackedEventIdRef = useRef<string | null>(null);

  useEffect(() => {
    if (!isInitialized || !pageContext?.basicInfo?.id) {
      return;
    }

    if (attributionTrackedEventIdRef.current === pageContext.basicInfo.id) {
      return;
    }

    const clickIds = extractFacebookClickIds();
    if (clickIds.fbclid && pageContext.basicInfo.organizationId) {
      sendClickData({
        organization_id: pageContext.basicInfo.organizationId,
        is_server_side_enabled: true,
        ...clickIds,
      }).catch((error: unknown) => {
        console.warn('Failed to send click data to attribution service:', error);
      });
    }

    attributionTrackedEventIdRef.current = pageContext.basicInfo.id;
  }, [pageContext, isInitialized, sendClickData]);
}
